export const LEAVE_CATEGORY = "Leave Type";
export const TYPE_OF_LEAVE = "Leave Duration";
export const DATES = "Date";
export const REASON = "Reason";
export const NUMBER_OF_DAYS = "Number Of Days";
export const EMPLOYEES_NAME = "Employee";
export const ACQUIRED_DATE = "Acquired Date";
export const NAME = "Name"
export const HR = "HR";
export const ADMIN = "Admin";
export const EMPLOYEE = "EMPLOYEE"
export const LEAVE_STATUS = "Leave Status"
export const FAILED_FETCH_MESSAGE = "Failed to fetch employees"
export const COMP_OFF_LEAVE = "Compoff Leave"
export const PROCESSING = "Processing"
export const AQUIRE_LEAVE = "Aquire Leave"
export const COL = "COL"
export const STATUS = "Status"
export const CANT_DELETE = "Cannot delete approved or rejected leaves" 
export const DELETE_LEAVE = "Delete Leave"
export const PENDING = "Pending"
export const CANT_DELETE_PENDING = "Cannot delete non-pending leaves"
export const CANT_EDIT_PENDING = "Cannot edit non-pending leaves"
export const NOT_FOUND_LEAVE = "Not Found leave record"
export const FULL = "Full"
export const LEAVE_ERROR = "Error submitting leave request"
export const UPDATE = "Update"
export const SUBMIT = "Submit"
export const SINGLE = "single"
export const RANGE = "range"
export const BDE = "BDE"
export const SUBMITING = "Submiting..."
export const UPDATE_EMP_LEAVE = "Update Employee Leave"
export const UPDATE_LEAVE = "Update Leave"
export const MANAGE_EMP_LEAVE = "Manage Employee Leave"
export const APPLY_LEAVE = "Apply Leave"